"use strict";
(self["descollabacc"] = self["descollabacc"] || []).push([[7],{},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [0,6,1,5,2,4,9], () => (__webpack_exec__("./src/solution/src/index.js")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);